import script from "./TenantPaymentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantPaymentsView.vue?vue&type=script&setup=true&lang=js"

import "./TenantPaymentsView.vue?vue&type=style&index=0&id=56daffd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56daffd0"]])

export default __exports__